import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";

const JobFindModeHistoryModal = (props) => {
    const [historyList, setHistoryList] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {candidateId, isShow, onClose} = props

    const fetchJobFindModeHistories = async (canId) => {
        if (!canId) {
            return;
        }
        const res = await CandidateService.getJobFindModeHistories(canId)
        if (res.sts_code === ResponseCode.SUCCESS) {
            setHistoryList(res.content)
        } else {
            setHistoryList([])
        }
    };

    const displayJobFindMode = (value) => {
        if (value === 1) {
            return "On"
        }
        if (value === 2) {
            return "Off"
        }
        return ""
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (isShow) {
            fetchJobFindModeHistories(candidateId)
        }
    }, [isShow]);

    const onCloseModal = () => {
        onClose()
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onCloseModal()}
                   animation={false} style={{zIndex: 3001}}>
                <Modal.Header>
                    <Modal.Title>Lịch sử nhập liệu chế độ tìm Job</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <table
                            className='table table-bordered table-hover text-center'
                        >
                            <thead>
                            <tr>
                                <th>No.</th>
                                <th>User NL</th>
                                <th>Giá trị NL</th>
                                <th>Thời gian NL</th>
                            </tr>
                            </thead>
                            <tbody>
                            {historyList && historyList.length > 0 && historyList.map((history, index) => (
                                <tr key={`template_${index}`}>
                                    <td>{history.no ? history.no : index + 1}</td>
                                    <td className={"text-truncate"}>{history.username}</td>
                                    <td className={"text-truncate"}>{displayJobFindMode(history.find_job_mode)}</td>
                                    <td className={"text-truncate"}>{history.updated_date_time}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default JobFindModeHistoryModal;
